export default __webpack_public_path__ + "static/media/174889.cdb8b968.jpg";